import React, { createContext, useState, useContext, useEffect } from 'react';
import { 
  signInWithPopup, 
  GoogleAuthProvider, 
  signOut 
} from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config'; // Update this path to match your Firebase config file

const AdminAuthContext = createContext();

export function useAdminAuth() {
  return useContext(AdminAuthContext);
}

export function AdminAuthProvider({ children }) {
  const [currentAdmin, setCurrentAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAdminStatus = async (user) => {
    if (!user) return false;
    
    const adminDoc = await getDoc(doc(db, 'admin_users', user.email));
    return adminDoc.exists() && adminDoc.data().isAdmin === true;
  };

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const isAdmin = await checkAdminStatus(result.user);
      
      if (!isAdmin) {
        await signOut(auth);
        throw new Error('Unauthorized access');
      }
      
      setCurrentAdmin(result.user);
      return result.user;
    } catch (error) {
      console.error('Sign-in error:', error);
      throw error;
    }
  };

  const logOut = () => signOut(auth);

  useEffect(() => {
    return auth.onAuthStateChanged(async (user) => {
      if (user) {
        const isAdmin = await checkAdminStatus(user);
        setCurrentAdmin(isAdmin ? user : null);
      } else {
        setCurrentAdmin(null);
      }
      setLoading(false);
    });
  }, []);

  const value = {
    currentAdmin,
    signInWithGoogle,
    logOut,
    loading
  };

  return (
    <AdminAuthContext.Provider value={value}>
      {!loading && children}
    </AdminAuthContext.Provider>
  );
}